export const base = {
  box_shadow: "0px 4px 15px 0px rgba(0,0,0,0.2)",
  border_radius: "8px",
};
